import React, { Component } from 'react'
import Layout from '../components/Layout';
import PageHead from '../components/pageHead';
import { Container, Row, Col } from 'react-bootstrap';
import SlectHeading from '../components/select-heading';
import SelectSection from '../components/select-button-section';
import SERVICES from '../services/service'
import Work from '../components/work';
import Partner from '../components/partner-sec';
import Testmonial from '../components/testmonials';
import Counter from '../components/counter-sec';
import SelectCity from '../components/select-city';
import { _getFilterArray, _proceedValue, _checkLocation,_getAllbrands } from '../utils';
import Router from 'next/router';
import cookies from 'next-cookies';
import Indiafaq from '../components/indiafaq';
import Mainpcontent from '../components/mainpcontent'
const metaData = {
    "metatitle" :'Apple iPhone, iPad, iWatch & MacBook Repair & Service Center Near Me',
    "metaDescription" : 'Trusted Apple product repair service in India. Get same-day doorstep service for iPhone, iPad, iWatch and MacBook. Resolve screen, display, and battery issues without warranty.',
    "metaKeywords" : '',
    "facebookDomain":'j14jtz8f94otxqjl3rpwehyach58j6'
}
export default class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            devices: this.props.devices,
            location : this.props.location == undefined ? 'location' : this.props.location
        }
    }

    static async getInitialProps(ctx) {
        let location = cookies(ctx).location
       var checklocation = await _checkLocation(ctx, location);
       let getAllBrands = await _getAllbrands()
        return { result : 'okay', "location" : location, devices: getAllBrands.devices ? getAllBrands.devices : []}
    }

    handleClose = () => {
        this.setState({
            show: false
        })
        this.setState({
            location : cookies({ "ctx": '' }).location
        })
    }

    handleOpen = () => {
        this.setState({
            show: true
        })
    }

    handleClose1 = () => { }

    getDevice = (device) => {
        let { devices } = this.state
        var cDevices = _getFilterArray(devices, device)
        this.setState({ devices: cDevices })
    }

    setDeviceName = () => {
        let { devices } = this.state
        var device_name = _proceedValue(devices)
        if (device_name == "") {

        } else {
            document.cookies = `device=` + device_name;
            // Router.push('/brand', '/brand')
        }
    }

    componentDidMount = () => {
       setTimeout(() => {
         this.setState({ show : this.props.location == undefined ? true : false })
       }, 1000);
    }

    render() {
        let { show, location } = this.state
        return (
            <div>
                <PageHead title="Gadget Zippy | Mobile repairs" meta={metaData} facebookmeta="j14jtz8f94otxqjl3rpwehyach58j6"></PageHead>
                <Layout route="Home" location={location} handleOpen={this.handleOpen}>
                    <div>
                        <Container>
                            <Row>
                                <Col className="pt-5">
                                    <div className="pt-sm-5 mt-sm-5">
                                        <div className="desktop test-test"></div>
                                        <div className="muted-text pt-sm-5 mt-sm-5 desktop">Lifetime Warranty • Lowest Price</div>
                                        <div className="muted-text pt-sm-5 mt-sm-5 mobile">Lifetime Warranty <br />Lowest Price</div>
                                        <p className="heading-text desktop">
                                            India’s Highest Rated iPhone Repairs at your <strong>doorstep</strong>
                                        </p>
                                        <p className="heading-text mobile pb-4">
                                            India’s <br />Highest Rated <br /><strong>Apple Repairs</strong><br />at your doorstep
                                        </p>
                                        <p className="name">PROFESSIONAL APPLE TECHNICIANS</p>
                                        <p className="name-mobile mobile">Most trusted iPad, Apple Watch, MacBook <br />& iPhone repair service in {location}</p>
                                    </div>
                                </Col>
                                <Col md className="pt-sm-5">
                                    <div className="desktop mt-4"></div><br />
                                    <div className="pt-sm-5 mt-sm-5">
                                        <SlectHeading name="Select your device to get started now!" />
                                        <div>
                                            <SelectSection
                                                devices={this.state.devices}
                                                getDevice={(device) => this.getDevice(device)}
                                                setDeviceName={this.setDeviceName} />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <br />
                        </Container>
                    </div>
                    <div className="mt-sm-4 mb-sm-4">
                        <Container fluid={true}>
                            <Work />
                        </Container>
                    </div>
                    <div className="mt-4 mb-4">
                        <Container fluid={true}>
                            <div className="text-center why-gadget pt-sm-5 pb-sm-4">Why GadgetZippy is your trusted partner</div>
                            <Container>
                                <div className="pl-sm-5 pr-sm-5 ipad-partner-box">
                                    <Partner />
                                </div>
                            </Container>
                        </Container>
                    </div>
                    <div className="mt-5 mb-5">
                        <Container>
                            <div className="pt-sm-5 pb-sm-5">
                                <Testmonial />
                            </div>
                        </Container>
                    </div>
                    <div className="mt-sm-5 mb-sm-5 pb-3 pt-3">
                        <Container>
                            <Counter />
                            <Mainpcontent />
                            <Indiafaq />
                        </Container>
                    </div>
                </Layout>
                {show && <SelectCity show={show} isClose={false} handleClose={this.handleClose} handleClose1={this.handleClose1} />}
            </div>
        )
    }
}

